import { SearchFilterLabelsSort } from '../option-labels/search-filter-labels.models';

export interface DateFilter {
  lower?: number;
  upper?: number;
}

export enum DateFilterType {
  startsAt = 'startsAt',
  endsAt = 'endsAt',
}

export interface StartsAtDateFilter {
  name: DateFilterType.startsAt;
  filters: DateFilter[];
}

export interface EndsAtDateFilter {
  name: DateFilterType.endsAt;
  filters: DateFilter[];
}

export type DateFilterValue = StartsAtDateFilter | EndsAtDateFilter;

export interface SearchFilterOption {
  key: string;
  label: string;
  icon?: string;
  disabled?: boolean;
}
/**
 * Interface for the 'SearchFilterOptions' data
 */
export interface SearchFilterOptionsEntity {
  key: string; // Primary ID
  label: string;
  icon?: string;
  filterType: SearchFilterType;
  values: { key: string; count: number; personalized: boolean }[];
}

export enum SearchFilterType {
  simple = 'SIMPLE',
  identity = 'IDENTITY',
  nested = 'NESTED',
}

export type SearchFilter = SimpleFilter | IdentityFilter | NestedFilter;

export interface SimpleFilter {
  key: string;
  filterType: SearchFilterType.simple;
  label: string;
  icon?: string;
  disabled?: boolean;
  sortOrder?: SearchFilterLabelsSort;
  values: {
    key: string;
    personalized: boolean;
    label?: string;
    count?: number;
    disabled?: boolean;
  }[];
}

export interface IdentityFilter {
  key: string;
  filterType: SearchFilterType.identity;
  label: string;
  icon?: string;
  disabled?: boolean;
  sortOrder?: SearchFilterLabelsSort;
  values: {
    key: string;
    label: string;
    personalized: boolean;
    count?: number;
    disabled?: boolean;
  }[];
}

export interface FilterValue {
  key: string;
  label: string;
  count: number;
  personalized: boolean;
  selectable?: boolean;
  disabled?: boolean;
}

export type NestedFilterValue = FilterValue & {
  values: DeepNestedFilterValue[];
  root_path: string[];
  external_id: string;
};

export type DeepNestedFilterValue = FilterValue & {
  values?: DeepNestedFilterValue[];
  root_path: string[];
  external_id: string;
};

export interface NestedFilter {
  key: string;
  filterType: SearchFilterType.nested;
  label: string;
  icon?: string;
  disabled?: boolean;
  sortOrder?: SearchFilterLabelsSort;
  values: NestedFilterValue[];
}

export interface StringFilter {
  [key: string]: string[];
}
